import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Multimedia/Privacy_Mask/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/MultimediaLivestreamPerm';
import PrivacyTable from 'components/Web_User_Interface/1440p_Series/Multimedia/Privacy_Mask/privacyTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Multimedia Menü // Privatsphäre Maske",
  "path": "/Web_User_Interface/1440p_Serie/Multimedia/Privat_Maske/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Das Menü Privatsphäre erlaubt Ihnen Bereiche aus Ihrer Überwachung auszuschwärzen. Zum Beispiel wenn Sie auf den Videos noch einen Teil der öffentlichen Straße sehen, Sie die Kamera aber nicht mehr weiter drehen können. Sie können jetzt bis zu 4 Masken einstellen um zu verhindern, dass die Straße in Ihren Überwachungsaufnahmen angezeigt wird - aktivieren Sie dazu einfach einen Bereich und zeichnen Sie ihn im Bild ein.",
  "image": "./WebUI_1440p_SearchThumb_Multimedia_Privat.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Multimedia_Privat.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Multimedia Menü // Privatsphäre Maske' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Das Menü Privatsphäre erlaubt Ihnen Bereiche aus Ihrer Überwachung auszuschwärzen. Zum Beispiel wenn Sie auf den Videos noch einen Teil der öffentlichen Straße sehen, Sie die Kamera aber nicht mehr weiter drehen können. Sie können jetzt bis zu 4 Masken einstellen um zu verhindern, dass die Straße in Ihren Überwachungsaufnahmen angezeigt wird - aktivieren Sie dazu einfach einen Bereich und zeichnen Sie ihn im Bild ein.' image='/images/Search/WebUI_1440p_SearchThumb_Multimedia_Privat.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Multimedia_Privat.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Multimedia/Privacy_Mask/' locationFR='/fr/Web_User_Interface/1440p_Series/Multimedia/Privacy_Mask/' crumbLabel="Privacy Mask" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "multimedia-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#multimedia-men%C3%BC",
        "aria-label": "multimedia menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Multimedia Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/77dec18ac10b05c056e69bc93e777150/610c0/1440p_Settings_Multimedia_Privacy.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.17391304347827%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAC7klEQVQoz02S2WsTURTG44LUpanVapM0yyRN7dw7M5mZTJNMFrvGdKaZSWYyc+9kqdW2uNUiaqVpI1oQBHF7EX2RqrigtSrqk4i4gaCIIvgPSdJW/fgevpffOYdzjo1l2RDL0hTkhJhWvW+ef6HOPVHmlpT5p0ptWak9reeG1bnH1oVX6NhCiCJdLpff77dRFAUhBCTJcvyAgqODajSjRTNarF+JJSUxJYvpfGwot+KEZMgqikcTgiD29Ih1mKIoAADP8cGgb8M6W8v6dTs3bHS6HB2ZpG88H9jd7m1tc7fubG7aZG9u2tc7JPXlkXkokx6xwYZIkuR5vhuQm1vtXj0TvDy75/XN4Pcl/5eHQno40s10upzb7NvsO1oMGR3JTR7KHcjLch1e7RwOw65gi9sRfHe78+tD34dF36e7e+9cqp2aHe7y7GreYrdvbWvboWazU0i7dgJPHEivwhBCnucjPL+7qYm4OkP8eBx9u4jOVGp72evF/MSgyHg7nNtbnO1OeXjobPX44o3qfpRcHRsAwHFcMtUH2t3h00d77904bGUxSWQh1du5RxVFPZYSAl1uh2t+dubXz2+/Xy5Vx3KrC4MAMKGQNDDQH03IadVSxymnJ0R095CRkJ+J+8FoLNPPJQiX7/LFhZ/v3/x4/uzW9MQaDCHNMIaWN9WsbpaQVdKVrJnL52RlRJI1NadI0khGkqWRi+eqn5cffFy+d+lY+T+Ypg3TxBhpYxPW2EGMEMKoXKlgCyOMKqOj2LKKpaIsy71xcVCMCjT4d2eapk3DKGKMrWK5XEH1QrhcKjWCVSqXDcMYrVTi8Xi7w+H2eD0+wkY3BCFkGEbXdRNhXdcRQqZpFgqFtaBjhAqGgTBOJZMEQQSDnYGA3wYACQAAZDegmPlJ9VEtPzVW0BoUQiusWZy+UDx5ZUHD1wtmXzzh8XoDgUD9tyFFAUhBSEGKFiNCKsIKYY7jeI7j2L8KR1ghFgmxIssCkiQIwt/QHxg/4QX3/QkIAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/77dec18ac10b05c056e69bc93e777150/e4706/1440p_Settings_Multimedia_Privacy.avif 230w", "/de/static/77dec18ac10b05c056e69bc93e777150/d1af7/1440p_Settings_Multimedia_Privacy.avif 460w", "/de/static/77dec18ac10b05c056e69bc93e777150/7f308/1440p_Settings_Multimedia_Privacy.avif 920w", "/de/static/77dec18ac10b05c056e69bc93e777150/42d56/1440p_Settings_Multimedia_Privacy.avif 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/77dec18ac10b05c056e69bc93e777150/a0b58/1440p_Settings_Multimedia_Privacy.webp 230w", "/de/static/77dec18ac10b05c056e69bc93e777150/bc10c/1440p_Settings_Multimedia_Privacy.webp 460w", "/de/static/77dec18ac10b05c056e69bc93e777150/966d8/1440p_Settings_Multimedia_Privacy.webp 920w", "/de/static/77dec18ac10b05c056e69bc93e777150/a8acc/1440p_Settings_Multimedia_Privacy.webp 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/77dec18ac10b05c056e69bc93e777150/81c8e/1440p_Settings_Multimedia_Privacy.png 230w", "/de/static/77dec18ac10b05c056e69bc93e777150/08a84/1440p_Settings_Multimedia_Privacy.png 460w", "/de/static/77dec18ac10b05c056e69bc93e777150/c0255/1440p_Settings_Multimedia_Privacy.png 920w", "/de/static/77dec18ac10b05c056e69bc93e777150/610c0/1440p_Settings_Multimedia_Privacy.png 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/77dec18ac10b05c056e69bc93e777150/c0255/1440p_Settings_Multimedia_Privacy.png",
              "alt": "Web User Interface - 1440p Series - Multimedia Privacy Mask",
              "title": "Web User Interface - 1440p Series - Multimedia Privacy Mask",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <PrivacyTable mdxType="PrivacyTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "bereiche-ihrer-überwachung-ausschwärzen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#bereiche-ihrer-%C3%BCberwachung-ausschw%C3%A4rzen",
        "aria-label": "bereiche ihrer überwachung ausschwärzen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bereiche Ihrer Überwachung ausschwärzen.`}</h2>
    <p>{`Das Menü Privatsphäre erlaubt Ihnen Bereiche aus Ihrer Überwachung auszuschwärzen. Zum Beispiel, wenn Sie auf den Videos noch einen Teil der öffentlichen Straße sehen, Sie die Kamera aber nicht mehr weiter drehen können. Sie können jetzt bis zu 4 Masken einstellen um zu verhindern, dass die Straße in Ihren Überwachungsaufnahmen angezeigt wird - aktivieren Sie dazu einfach einen Bereich und zeichnen Sie ihn im Bild ein.`}</p>
    <p><strong parentName="p">{`Tip:`}</strong>{` Sie können die Privatsphärenmaske verwenden, um Bereiche vor den `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Bereiche/"
      }}>{`Bewegungserkennungs zu verbergen`}</a>{` um falsche Auslöser zu vermeiden.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      